import { AdminLoadingText } from '@/components/shared/AdminLoadingText'
import { useFetchGenericUser } from '@/hooks/useFetchUsers'

type Props = {
  userId: string | undefined
}

export const AdminUserLink = ({ userId }: Props) => {
  const { data: user, isLoading } = useFetchGenericUser(userId)

  if (!userId) {
    return <span className="text-fv-gray">—</span>
  }

  const displayName = user
    ? user.firstName || user.lastName
      ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
      : user.email
    : null

  return (
    <AdminLoadingText isLoading={isLoading} loadingText={userId}>
      {displayName ? (
        <div className="flex flex-col">
          <span>{displayName}</span>
          {user?.email && displayName !== user.email && (
            <small className="text-fv-gray">{user.email}</small>
          )}
        </div>
      ) : (
        <span className="text-fv-gray">{userId}</span>
      )}
    </AdminLoadingText>
  )
}
